import React, { useEffect, useState } from "react";

const MESSAGES = [
    "🇨🇦 Free Shipping Canada-Wide on Orders Over $150 CAD",
    "💰 Spend $250 CAD or More and Save 10% Automatically",
    "🚚 Flat-Rate Shipping: $19.99 CAD",
    "🔬 Premium Research Products • New Inventory Added Regularly",
];

const ROTATE_MS = 5000;
const TRANSITION_MS = 700;

export const AnnouncementBar = () => {
    const [index, setIndex] = useState(0);
    const [phase, setPhase] = useState("in"); // "in" | "out"

    useEffect(() => {
        const id = window.setInterval(() => {
            setPhase("out");
            window.setTimeout(() => {
                setIndex((i) => (i + 1) % MESSAGES.length);
                setPhase("in");
            }, TRANSITION_MS);
        }, ROTATE_MS);
        return () => window.clearInterval(id);
    }, []);

    const slideStyle = {
        transition: `opacity ${TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1), transform ${TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1)`,
        opacity: phase === "in" ? 1 : 0,
        transform: phase === "in" ? "translateX(0)" : "translateX(14px)",
    };

    return (
        <div
            className="relative w-full overflow-hidden border-b border-white/5 bg-[#070710]"
            data-testid="announcement-bar"
            aria-label="Announcement"
        >
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-indigo-600/0 via-indigo-600/8 to-violet-600/0" />
            <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-0 h-full w-[60%] bg-indigo-500/8 blur-2xl" />

            <div className="relative max-w-7xl mx-auto px-5 lg:px-10 h-9 flex items-center justify-center">
                <span
                    key={index}
                    style={slideStyle}
                    className="inline-flex items-center gap-2 text-[10px] sm:text-[11px] uppercase tracking-[0.28em] text-indigo-200/90"
                >
                    <span className="w-1 h-1 rounded-full bg-indigo-400 shadow-[0_0_8px_rgba(129,140,248,0.7)]" />
                    {MESSAGES[index]}
                    <span className="w-1 h-1 rounded-full bg-indigo-400 shadow-[0_0_8px_rgba(129,140,248,0.7)]" />
                </span>
            </div>
        </div>
    );
};

export default AnnouncementBar;
